import { makeStyles, tokens } from '@fluentui/react-components';

const LEFT_PANE_WIDTH = '300px';

export const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'row',
    height: '100%',
    minHeight: 0,
    minWidth: 0,
  },

  // ── Left pane: file picker ────────────────────────────────────────────────

  leftPane: {
    display: 'flex',
    flexDirection: 'column',
    width: LEFT_PANE_WIDTH,
    flexShrink: 0,
    minHeight: 0,
    borderRight: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke2}`,
  },

  leftHeader: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: tokens.spacingVerticalXXS,
    padding: tokens.spacingHorizontalM,
    borderBottom: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke2}`,
  },

  leftHeaderTop: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    columnGap: tokens.spacingHorizontalS,
  },

  datasetName: {
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },

  entryCount: {
    color: tokens.colorNeutralForeground3,
  },

  list: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
    overflowY: 'auto',
  },

  listStatus: {
    padding: tokens.spacingHorizontalM,
    color: tokens.colorNeutralForeground3,
  },

  loadMoreRow: {
    display: 'flex',
    justifyContent: 'center',
    padding: tokens.spacingVerticalS,
  },

  // ── Right pane: editor ────────────────────────────────────────────────────

  rightPane: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    minWidth: 0,
    minHeight: 0,
    paddingTop: tokens.spacingVerticalM,
    paddingInline: tokens.spacingHorizontalL,
    overflow: 'hidden',
  },

  emptyEditor: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    rowGap: tokens.spacingVerticalS,
    height: '100%',
    padding: tokens.spacingHorizontalXXL,
    color: tokens.colorNeutralForeground3,
    textAlign: 'center',
  },

  emptyEditorIcon: {
    fontSize: tokens.fontSizeHero700,
    color: tokens.colorNeutralForeground4,
  },
});
